/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-tabindex */
import React from 'react';
import propTypes from 'prop-types';
import { Portal } from '../Portal';
import { dialogStateProps } from '../Dialog';

export function Modal({
  title,
  className,
  children,
  id = 'tds-modal',
  dialogState: {
    isOpen,
    closeModal,
    dialogRef,
    firstElementRef,
    lastElementRef,
  },
}) {
  return isOpen ? (
    <Portal selector="#react-modal-outlet">
      <div
        data-testid="modal-overlay"
        className="modal-overlay util-z-index-9"
        hidden={!isOpen}
        aria-hidden={!isOpen}
        onClick={closeModal}
      />
      <div
        role="dialog"
        data-testid="modal-dialog"
        className="modal util-z-index-10"
        aria-labelledby={`${id}--title`}
        aria-describedby={`${id}--description`}
        aria-modal="true"
        hidden={!isOpen}
        ref={dialogRef}
        tabIndex={0}
      >
        <h2
          data-testid="modal-title"
          className="modal__title util-weight-bold"
          id={`${id}--title`}
          ref={firstElementRef}
          tabIndex={0}
        >
          {title}
        </h2>
        <div id={`${id}--description`} className={`modal__content ${className}`}>
          {children}
        </div>
        <button
          type="button"
          data-testid="modal-close-button"
          aria-label="Close modal"
          className="modal__close-button"
          ref={lastElementRef}
          onClick={closeModal}
        >
          &times;
        </button>
      </div>
    </Portal>
  ) : null;
}

Modal.propTypes = {
  title: propTypes.string,
  className: propTypes.string,
  children: propTypes.oneOfType([
    propTypes.arrayOf(propTypes.node),
    propTypes.node,
    propTypes.string,
  ]).isRequired,
  id: propTypes.string,
  dialogState: dialogStateProps,
};
